import { useRef, useState, useEffect } from 'react'

export const useDrop = () => {
  const [dragOver, setDragOver] = useState(false)
  const [droppedItems, setDroppedItems] = useState([])
  const [items, setItems] = useState([])
  const ref = useRef()

  const drop = (ev) => {
    ev.preventDefault()
    ev.stopPropagation()
    const { files } = ev.dataTransfer
    const value = []

    for (let i = 0; i < files.length; i++) {
      const file = files.item(i)
      value.push(file)
    }

    setDroppedItems(value)
    setDragOver(false)
  }

  const dragEnter = (ev) => {
    ev.preventDefault()
    setDragOver(true)
  }
  const dragLeave = (ev) => {
    ev.preventDefault()
    setDragOver(false)
  }

  useEffect(() => {
    const target = ref?.current
    if (target) {
      target.addEventListener('dragenter', dragEnter)
      target.addEventListener('dragover', dragEnter)
      target.addEventListener('dragleave', dragLeave)
      target.addEventListener('drop', drop)
    }
    return () => {
      target.removeEventListener('dragenter', dragEnter)
      target.removeEventListener('dragover', dragEnter)
      target.removeEventListener('dragleave', dragLeave)
      target.removeEventListener('drop', drop)
    }
  }, [ref])

  useEffect(() => {
    setItems([...items, ...droppedItems])
  }, [droppedItems])

  return { dragOver, items, dropRef: ref }
}
